import React, { useRef, useState } from "react";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { IconDownloadArrow, IconFilter, IconSearch } from "../../../icon/icons";
import "./commonfilters.scss";
import FlatpickrAll from "../flatpickrall";
import Flatpickr from "react-flatpickr";

import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import FilterModal from "../filtermodal";
import CommonFiltersUtils from "./commonfiltersUtils";

const CommonFilters = ({
  heading,
  isDatebtn = false,
  onViewChange,
  handleSearch,
  handleFilter,
  handleDownload,
  handleDownloadPdf,
  placeholderText = "Search",
  filterFields = [],
}) => {
  const [activeTab, setActiveTab] = useState("list");
  const [filterValues, setFilterValues] = useState({});
  const refComp = useRef(null);
  const debounceRef = useRef(null);

  const {
    showProfilemodal,
    setShowProfileModal,
    handleCloseProfilemodal,
    handleShowProfilemodal,
  } = CommonFiltersUtils();

  const handleTabChange = (view) => {
    setActiveTab(view);
    onViewChange(view);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleApplyFilters = () => {
    handleFilter(filterValues);
    handleCloseProfilemodal();
  };

  const handleFilterChange = (fieldName, value) => {
    setFilterValues((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };


  
  const handleDateChange = (selectedDates, dateStr) => {
    if (selectedDates.length === 2) {
      const [startDate, endDate] = selectedDates;
      const formattedStartDate = flatpickr.formatDate(startDate, "Y-m-d");
      const formattedEndDate = flatpickr.formatDate(endDate, "Y-m-d");

      setFilterValues({
        ...filterValues,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      });
    } else {
      // setFilterValues({
      //   ...filterValues,
      //   startDate: null,
      //   endDate: null,
      // });
    }
  };

  const handleSearchSubmit = (e) => {
    setFilterValues((prev) => ({
      ...prev,
      search: e.target.value,
    }));

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      handleSearch(e.target.value);
    }, 500);
  };

  const clearFilters = () => {
    if (refComp.current) refComp.current.flatpickr.clear();

    const resetFilters = filterFields.reduce((acc, field) => {
      if (field.type === "autocomplete") {
        acc[field.name] = null;
      }
      return acc;
    }, {});

    handleFilter({});

    setTimeout(() => {
      setFilterValues({
        ...resetFilters,
        search: "",
        startDate: null,
        endDate: null,
      });
    }, 0);

    handleCloseProfilemodal();
  };

  return (
    <div className="common-filter-main">
      <div className="flex-dis">
        <div className="heading-main">
          <h2 className="common-heading">{heading}</h2>
        </div>

        <div className="filer-all-btn">
          {/* Tab buttons */}
          {onViewChange ? (
            <div className="tab-toggle-container">
              <button
                className={`tab-button ${
                  activeTab === "kanban" ? "active" : ""
                }`}
                onClick={() => handleTabChange("kanban")}
              >
                Kanban View
              </button>
              <button
                className={`tab-button ${activeTab === "list" ? "active" : ""}`}
                onClick={() => handleTabChange("list")}
              >
                List View
              </button>
            </div>
          ) : (
            ""
          )}

      { handleSearch &&   <div className="search-input">
            <div className="input-main-all">
              <span>
                <IconSearch />
              </span>
              <input
                placeholder= {placeholderText}
                value={filterValues?.search}
                onChange={handleSearchSubmit}
              />
            </div>
          </div>}

          {handleFilter ? (
            <div className="btn-filter-main">
              <button
                className="common-button-light"
                onClick={() => handleShowProfilemodal()}
              >
                <span>
                  <IconFilter />
                </span>
                <p> Filters</p>
              </button>
            </div>
          ) : (
            ""
          )}
          {/* 
          <div className="title-button-data">
            <button className="common-button btn-download-data">
              {" "}
              Download <IconDownloadArrow />
            </button>
          </div> */}

          {handleDownload &&<div className="title-button-data">
            <button
              className="common-button btn-download-data"
              id="demo-customized-button"
              aria-controls={open ? "demo-customized-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              Download <IconDownloadArrow />
            </button>
            <Menu
              id="demo-customized-menu"
              MenuListProps={{
                "aria-labelledby": "demo-customized-button",
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
            >
              <MenuItem
                onClick={() => {
                  handleDownload();
                  handleClose();
                }}
                disableRipple
              >
                Excel
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleDownloadPdf();
                  handleClose();
                }}
                disableRipple
              >
                PDF
              </MenuItem>
            </Menu>
          </div>}
        </div>
      </div>

      <FilterModal
        showProfilemodal={showProfilemodal}
        handleCloseProfilemodal={handleCloseProfilemodal}
        filterFields={filterFields}
        filterValues={filterValues}
        handleFilterChange={handleFilterChange}
        isDatebtn={isDatebtn}
        refComp={refComp}
        handleDateChange={handleDateChange}
        clearFilters={clearFilters}
        handleApplyFilters={handleApplyFilters}
      />
    </div>
  );
};

export default CommonFilters;
